module.exports = __webpack_public_path__ + "img/service-parts-display-parallax-red.c2f354de.png";